import { render, staticRenderFns } from "./Aid.vue?vue&type=template&id=3b84072a&"
import script from "./Aid.vue?vue&type=script&lang=js&"
export * from "./Aid.vue?vue&type=script&lang=js&"
import style0 from "./Aid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports